const rewrites = [
  { source: '/abonnement', destination: '/subscription' },
  { source: '/abonnement/abschluss', destination: '/subscription/confirmation' },
  { source: '/ausschreibungen/:tenderCode/:tenderSlug', destination: '/tenders/:tenderCode/:tenderSlug' },
  { source: '/ausschreibungen', destination: '/tenders' },
  {
    source: '/ausschreibungen/:tenderCode/:tenderSlug/quelle',
    destination: '/tenders/:tenderCode/:tenderSlug/origin',
  },
  { source: '/datenschutz', destination: '/data-privacy' },
  { source: '/organisation', destination: '/organization' },
  { source: '/impressum', destination: '/imprint' },
  { source: '/profil', destination: '/profile' },
  { source: '/registrierung', destination: '/registration' },
  { source: '/suche', destination: '/search' },
  { source: '/suchprofile', destination: '/agents' },
  { source: '/suchergebnisse', destination: '/search-results' },
  { source: '/favoriten', destination: '/favorites' },
  { source: '/suche/:searchExecutionId', destination: '/search/:searchExecutionId' },
  { source: '/agb', destination: '/terms-of-use' },
  { source: '/tenders-sitemap.xml', destination: '/sitemaps/tenders/sitemap.xml' },
  { source: '/page-sitemap.xml', destination: '/sitemaps/page/sitemap.xml' },
  { source: '/nuts-sitemap.xml', destination: '/sitemaps/nuts/sitemap.xml' },
  { source: '/cpv-sitemap.xml', destination: '/sitemaps/cpv/sitemap.xml' },
  { source: '/blog-sitemap.xml', destination: '/sitemaps/blog/sitemap.xml' },
  { source: '/ausschreibungen/nuts/:code/:label', destination: '/tenders/nuts/:code/:label' },
  { source: '/ausschreibungen/cpv/:code/:label', destination: '/tenders/cpv/:code/:label' },
  { source: '/preise', destination: '/pricing' },
  { source: '/glossar', destination: '/glossary' },
  { source: '/glossar/:entrySlug', destination: '/glossary/:entrySlug' },
  { source: '/glossary-sitemap.xml', destination: '/sitemaps/glossary/sitemap.xml' },
  { source: '/rechnung', destination: '/invoice' },
  { source: '/iframe/suche', destination: '/iframe/search' },
];

const getSourcePath = (destination) => {
  const rewrite = rewrites.find((r) => r.destination === destination);
  return rewrite ? rewrite.source : destination;
};

module.exports = {
  rewrites,
  getSourcePath,
};
